<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.cinemaWebsite.colorStyleSetting") }}</h1>
    <el-form
      class="egl-elm egl-detail"
      :model="websiteGuideSettingInfo"
      label-position="top"
    >
      <el-row style="margin-top: 11px;">
        <el-col :span="12" v-for="item in formItems" :key="item.prop" >
          <el-form-item
            :label="item.label"
            :prop="item.prop"
          >
            <div class="color-picker-cinemaWebsite">
              <div class="bg" :style="{backgroundColor: websiteGuideSettingInfo[item.prop]}">
                <el-color-picker v-model="websiteGuideSettingInfo[item.prop]" />
              </div>
              <span>{{websiteGuideSettingInfo[item.prop]}}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" style="margin-top:40px;text-indent: 230px;">
        <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getWebsiteSettingGuideService, updateWebsiteSettingGuideService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      websiteGuideSettingInfo: {
        backgroundColor: "#181818",
        cardBackgroundColor: "#181818",
        mainColor: "#181818",
        labelBackgroundColor: "#181818",
        mainFontColor: "#181818",
        btnFontColor: "#181818",
        btnTextColorSelected: "#181818",
        secondaryFontColor: "#181818",
        navBarFontColor: "#181818",
        navBarFontColorSelected: "#181818",
        navBarBackgroundColor: "#181818",
      },
      formItems: [
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.backgroundColor"),
          prop: "backgroundColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.btnTextColorSelected"),
          prop: "btnTextColorSelected"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.cardBackgroundColor"),
          prop: "cardBackgroundColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.secondaryFontColor"),
          prop: "secondaryFontColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.mainColor"),
          prop: "mainColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.navBarFontColor"),
          prop: "navBarFontColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.labelBackgroundColor"),
          prop: "labelBackgroundColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.navBarFontColorSelected"),
          prop: "navBarFontColorSelected"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.mainFontColor"),
          prop: "mainFontColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.navBarBackgroundColor"),
          prop: "navBarBackgroundColor"
        },
        {
          label: this.$locale("cinemaWebsite.colorStyleSetting.formItem.btnFontColor"),
          prop: "btnFontColor"
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // Object.keys(this.websiteGuideSettingInfo).forEach(key => {
      //   this.websiteGuideSettingInfo[key] = "";
      // });
      getWebsiteSettingGuideService({
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        this.websiteGuideSettingInfo = res.data;
      });
    },
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText
      });
    },
    save_fn() {
      const requestParam = {
        ...this.websiteGuideSettingInfo,
        cinemaId: window.localStorage.getItem("cinemaId"),
      };
      updateWebsiteSettingGuideService(requestParam).then(res => {
        this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
      });
    }
  }
};
</script>